module.exports = __webpack_public_path__ + "static/ChrisLarsonSignature-c6b04ddcd274e9b082e81581c24cde18.png";